<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KhcdT/tc-custom/9780544716971.jpg?1699127787375" alt="This image is the cover for the book Line Made by Walking"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Line Made by Walking
      </h1>
      <p class="bookDescription body article font2">
        <b>A young artist in the midst of a breakdown escapes to the Irish countryside in this “cleareyed, beautiful rendering of a woman struggling against despair</b><b>” (<i>Kirkus</i>).</b><br/>  <br/><b>Shortlisted for the Goldsmiths Prize</b><br/><br/> A twenty-something artist, Frankie is struggling to cope with urban life—and life in general. So she retreats to her family’s rural house on “turbine hill,” vacant since her grandmother’s death three years earlier. Surrounded by countryside and wild creatures, she can finally grapple with the chain of events that led her here—her shaky mental health, her difficult time in art school—and maybe even regain her footing in art and life.<br/><br/> Reconsidering the relevance of art and closely examining the natural world around her, Frankie begins to pick up photography once more. With “prose that makes sure we look and listen,” Sara Baume has written an intimate and powerful novel that is also a meditation on wildness, community, the art world, and mental illness (<i>Atlantic</i>).<br/>  <br/><b>“Fascinating, because of the cumulative power of the precise, pleasingly rhythmic sentences, and the unpredictable intelligence of the narrator’s mind.” <i>—Guardian</i>, UK</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sara Baume
      </h2>
      
      <p class="authorDescription body article">SARA BAUME studied fine art before earning a master’s in creative writing. Her first novel, Spill Simmer Falter Wither, won the Rooney Prize for Irish Literature, the Sunday Independent Newcomer of the Year Award, the Geoffrey Faber Memorial Prize, and was short-listed for the Costa First Novel Award. She is also the recipient of the Davy Byrnes Short Story Award and the Hennessy New Irish Writing Award, and lives in Cork, Ireland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e4a6bb0